<app-page-header
  title="Home"
  active_item="Credenciais Bancárias"
  titleLink="/reports"
>
</app-page-header>

<div class="loading-transfer-balance" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>

<div class="row" *ngIf="isLoaded">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title">Credenciais Bancárias</div>
      </div>

      <div class="card-body pt-4">
        <div
          class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4"
        >
          <div class="text-muted small">
            Provedor atual: <strong>{{ providerTitle }}</strong>
          </div>

          <button
            type="button"
            class="btn btn-primary btn-pill"
            (click)="save()"
            [disabled]="isSaving || validatingTotp || !bankProvider"
          >
          <i class="fe fe-save me-2"></i>
            Salvar
          </button>
        </div>

        <div *ngIf="bankProvider; else noProviderTemplate">
          <div class="border-top">
            <div class="wideget-user-tab">
              <div class="tab-menu-heading">
                <div class="tabs-menu1">
                  <ul
                    ngbNav
                    #providerNav="ngbNav"
                    [(activeId)]="selectedProviderTab"
                    class="mb-4"
                  >
                    <ng-container
                      *ngFor="let tab of providerTabs; let i = index"
                    >
                      <li [ngbNavItem]="i + 1" [disabled]="!tab.isReal">
                        <a
                          ngbNavLink
                          [ngClass]="{ 'provider-tab-locked': !tab.isReal }"
                        >
                          <span>{{ tab.label }}</span>
                          <i
                            *ngIf="!tab.isReal"
                            class="fe fe-lock provider-tab-lock-icon"
                            aria-hidden="true"
                          ></i>
                        </a>

                        <ng-template ngbNavContent>
                          <ng-container *ngIf="tab.isReal">
                            <form [formGroup]="form">
                              <div class="mb-4 section-block">
                                <h4 class="section-title mb-3">
                                  Dados Bancários
                                </h4>

                                <div class="row g-3">
                                  <div class="col-xl-3 col-md-6">
                                    <label class="form-label"
                                      >Taxa Bancária Saque (Fixo R$)</label
                                    >
                                    <input
                                      class="form-control"
                                      type="text"
                                      formControlName="withdrawTaxValue"
                                      currencyMask
                                      [options]="{
                                        prefix: 'R$ ',
                                        allowNegative: false,
                                      }"
                                    />
                                  </div>

                                  <div class="col-xl-3 col-md-6">
                                    <label class="form-label"
                                      >Taxa Bancária Saque (%)</label
                                    >
                                    <input
                                      class="form-control"
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      formControlName="withdrawTaxPercent"
                                    />
                                  </div>

                                  <div class="col-xl-3 col-md-6">
                                    <label class="form-label"
                                      >Taxa Bancária Depósito (Fixo R$)</label
                                    >
                                    <input
                                      class="form-control"
                                      type="text"
                                      formControlName="depositTaxValue"
                                      currencyMask
                                      [options]="{
                                        prefix: 'R$ ',
                                        allowNegative: false,
                                      }"
                                    />
                                  </div>

                                  <div class="col-xl-3 col-md-6">
                                    <label class="form-label"
                                      >Taxa Bancária Depósito (%)</label
                                    >
                                    <input
                                      class="form-control"
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      formControlName="depositTaxPercent"
                                    />
                                  </div>

                                  <div class="col-xl-4 col-md-6">
                                    <label class="form-label">Chave Pix</label>
                                    <div class="input-icon-container">
                                      <input
                                        class="form-control"
                                        type="text"
                                        formControlName="pixKey"
                                      />
                                      <i
                                        class="fe fe-clipboard input-icon"
                                        title="Colar"
                                        (click)="paste('pixKey')"
                                      ></i>
                                    </div>
                                  </div>

                                  <div class="col-xl-4 col-md-6">
                                    <label class="form-label">Agência</label>
                                    <input
                                      class="form-control"
                                      type="text"
                                      formControlName="saQAG"
                                    />
                                  </div>

                                  <div class="col-xl-4 col-md-6">
                                    <label class="form-label"
                                      >Conta Corrente</label
                                    >
                                    <input
                                      class="form-control"
                                      type="text"
                                      formControlName="saQCC"
                                    />
                                  </div>
                                </div>
                              </div>

                              <hr class="my-4" />

                              <div class="mb-4 section-block">
                                <h4 class="section-title mb-3">
                                  Credenciais Bancárias
                                </h4>

                                <div
                                  *ngIf="providerExtraFields.length === 0"
                                  class="text-muted"
                                >
                                  Não há campos de credenciais mapeados para
                                  este provedor.
                                </div>

                                <div
                                  class="row g-3"
                                  *ngIf="providerExtraFields.length > 0"
                                >
                                  <div
                                    class="col-xl-6 col-md-6"
                                    *ngFor="let field of providerExtraFields"
                                  >
                                    <label class="form-label">{{
                                      field.label
                                    }}</label>
                                    <div class="input-icon-container">
                                      <input
                                        class="form-control"
                                        [type]="field.type || 'text'"
                                        [formControlName]="field.key"
                                      />
                                      <i
                                        class="fe fe-clipboard input-icon"
                                        title="Colar"
                                        (click)="paste(field.key)"
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <hr class="my-4" />

                              <div class="mb-4 section-block">
                                <h4 class="section-title mb-3">
                                  Webhook para Cadastrar
                                </h4>

                                <div
                                  *ngIf="visibleWebhooks.length === 0"
                                  class="text-muted"
                                >
                                  Nenhum webhook disponível para este provedor.
                                </div>

                                <div
                                  class="row g-3"
                                  *ngIf="visibleWebhooks.length > 0"
                                >
                                  <div
                                    class="col-xl-6 col-md-6"
                                    *ngFor="let hook of visibleWebhooks"
                                  >
                                    <label class="form-label">{{
                                      hook.label
                                    }}</label>
                                    <div class="input-icon-container">
                                      <input
                                        class="form-control"
                                        type="text"
                                        [value]="hook.value"
                                        readonly
                                      />
                                      <i
                                        class="fe fe-copy input-icon"
                                        (click)="copyId(hook.value)"
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </ng-container>
                        </ng-template>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div [ngbNavOutlet]="providerNav"></div>
        </div>

        <ng-template #noProviderTemplate>
          <div class="text-muted mt-3">
            Nenhum bank provider encontrado para esta conta.
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #requestTOTPCode let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Informe o token de autenticação</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="form-group mt-2">
      <p *ngIf="errorMessage && errorMessage.length > 0" class="text-danger">
        {{ errorMessage }}
      </p>
    </div>

    <div class="form-group mb-3">
      <input
        type="text"
        class="form-control"
        placeholder="Token"
        [(ngModel)]="validationCode"
        [ngModelOptions]="{ standalone: true }"
        (keyup.enter)="validateTotp()"
      />

      <button
        type="button"
        (click)="pasteTotpCode()"
        class="btn btn-primary btn-block btn-colar h-30 w-30 mx-auto mt-2 mb-1"
      >
        {{ "login.totp.pasteButton" | translate }}
      </button>
    </div>
  </div>

  <div class="modal-footer text-center">
    <button
      type="button"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="validateTotp()"
      [disabled]="validatingTotp || isSaving"
    >
      VALIDAR
    </button>
  </div>
</ng-template>
